import { validateServerData } from '@wwt/core/admin'
import {
	OfferIdsDto,
	SaveDislikeResponseDto
} from '@wwt/entities/api/search-response'

import { api } from '@/shared/api/client'

export const dislikeQuery = async (offerIds: OfferIdsDto) => {
	const response = await api().post(offerIds, '/v1/offers/dislikes').json()

	return validateServerData(response, SaveDislikeResponseDto, 'Dislike')
}
